export default __webpack_public_path__ + "static/media/user.7a7cdd4a.jpg";